module.exports = __webpack_public_path__ + "static/media/symbols.7530974a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/standard-sprite/svg/symbols.svg
// module id = 467
// module chunks = 0